import React, { useEffect, useState, useMemo } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { myInternshipsList } from "../user.api";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Pagination from "../../../components/page/companyDirectory/companyPagination";
import BreadCrumpBack from "../../../components/navigator/back";
import "./style.css";

const PageSize = 9;

export default function RegisteredInternships(props) {
  const history = useHistory();
  const [searchData, setSearchData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const servInstance = (typeof process !== "undefined" && process.env?.REACT_APP_BASE_URL) || "";
  let result = servInstance
    ? servInstance.substring(0, servInstance?.length - 4)
    : "";

  useEffect(() => {
    fetchInternships();
  }, []);

  const fetchInternships = () => {
    setIsLoading(true);
    myInternshipsList()
      .then((res) => {
        if (res?.success) {
          // Flatten application and proposals to show each preference as a card
          const flattenedData = [];
          (res.data || []).forEach(app => {
            if (app.proposals && app.proposals.length > 0) {
              app.proposals.forEach(prop => {
                flattenedData.push({
                  ...prop,
                  application_id: app.application_id,
                  full_name: app.full_name,
                  email: app.email,
                  phone_no: app.phone_no,
                  app_created_at: app.created_at
                });
              });
            } else {
              // Application without specific proposals (fallback case)
              flattenedData.push({
                application_id: app.application_id,
                full_name: app.full_name,
                email: app.email,
                phone_no: app.phone_no,
                app_created_at: app.created_at,
                internship_title: "General Registration",
                company_name: "KSPACE Internship Pool",
                status: "Pending"
              });
            }
          });
          setSearchData(flattenedData);
        } else {
          setSnackMessage("Failed to load registered internships");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching internships:", error);
        setSnackMessage("Error loading registered internships");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const mainData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return searchData.slice(firstPageIndex, lastPageIndex);
  }, [searchData, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
      case "ranking_confirmed":
      case "certified":
      case "completed":
      case "evaluated":
      case "absorbed":
      case "join_internship":
      case "allotted":
      case "doing":
      case "evaluation":
        return "approved";
      case "rejected":
      case "initially_rejected":
        return "rejected";
      case "pending":
      default:
        return "pending";
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
      case "ranking_confirmed":
      case "certified":
      case "completed":
      case "evaluated":
      case "absorbed":
      case "join_internship":
      case "allotted":
      case "doing":
      case "evaluation":
        return "success";
      case "rejected":
      case "initially_rejected":
        return "danger";
      case "pending":
      default:
        return "warning";
    }
  };

  const getStatusText = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
      case "ranking_confirmed":
        return "Approved";
      case "join_internship":
      case "allotted":
        return "Assigned to Company";
      case "doing":
        return "Internship in Progress";
      case "evaluation":
        return "Evaluation Initiated";
      case "evaluated":
        return "Evaluation Completed";
      case "certified":
        return "Certificate Issued";
      case "completed":
        return "Internship Completed";
      case "absorbed":
        return "Absorb into Company";
      case "rejected":
      case "initially_rejected":
        return "Rejected";
      case "pending":
        return "Pending";
      default:
        return status ? status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ") : "Pending";
    }
  };

  const handleViewDetails = (id) => {
    if (id) {
      history.push(`/internship-applied/${id}`);
    }
  };

  return (
    <div className="registered-internships-page">
      <Loader open={isLoading} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="dash-banner">
        <div className="tit-txt">
          {props.state.language === "ma" ? "രജിസ്റ്റർ ചെയ്ത ഇന്റേൺഷിപ്പുകൾ" : "Registered Internships"}
        </div>
      </div>

      <BreadCrumpBack />

      <div className="container-fluid px-4 px-md-5 py-4">
        <div className="d-flex justify-content-end align-items-center mb-4">
          <button
            className="btn btn-minimal-dark"
            onClick={() => history.push("/internship-history")}
          >
            <i className="fa fa-history me-2"></i>
            {props.state.language === "ma" ? "ഇന്റേൺഷിപ്പ് ഹിസ്റ്ററി" : "Internship History"}
          </button>
        </div>

        {mainData && mainData.length > 0 ? (
          <>
            <div className="row">
              {mainData.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className={`card internship-card h-100 border-0 status-border-${getStatusClass(item.status)}`}>
                    <div className="card-body d-flex flex-column p-4">
                      <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-2">
                        <div className="flex-grow-1">
                          <div className="company-info d-flex align-items-center mb-2">
                            {item.internship_request?.company?.logo ? (
                              <img
                                src={result + item.internship_request.company.logo}
                                alt="Logo"
                                className="company-logo-sm me-2 rounded"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  objectFit: "contain",
                                }}
                              />
                            ) : (
                              <div
                                className="company-logo-placeholder me-2 d-flex align-items-center justify-content-center bg-light text-muted small"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "4px",
                                }}
                              >
                                <i className="fa fa-building"></i>
                              </div>
                            )}
                            <span
                              className="text-primary font-weight-bold"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {item.company_name || item.internship_request?.company?.company_name || "KSPACE Community"}
                            </span>
                          </div>
                          <h5 className="card-title text-dark font-weight-bold mb-1" style={{ fontSize: "1.1rem" }}>
                            {item.internship_title || item.internship_request?.internship_discipline || "Internship Program"}
                          </h5>
                        </div>
                        <span
                          className={`badge bg-${getStatusBadgeClass(item.status)} ${getStatusBadgeClass(item.status) === 'warning' ? 'text-dark' : 'text-white'} px-2 py-1`}
                          style={{ fontSize: "0.75rem", borderRadius: "4px" }}
                        >
                          {getStatusText(item.status)}
                        </span>
                      </div>

                      <div className="internship-details-container mt-2 mb-3 flex-grow-1" style={{ fontSize: "0.85rem" }}>
                        <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                          <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Applied Date</div>
                          <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                          <div className="col-12 col-sm-6 text-dark">{moment(item.app_created_at).format("DD-MMM-YYYY")}</div>
                        </div>
                        <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                          <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Preference Order</div>
                          <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                          <div className="col-12 col-sm-6 text-dark font-weight-bold">#{item.preference_order || "1"}</div>
                        </div>
                        <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                          <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Applicant Ref ID</div>
                          <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                          <div className="col-12 col-sm-6 text-dark">#{item.application_id}</div>
                        </div>
                      </div>

                      <button
                        className="btn btn-outline-primary mt-auto py-2 font-weight-bold"
                        style={{
                          borderRadius: "6px",
                          fontSize: "13px",
                          borderColor: "#1a233a",
                          color: "#1a233a",
                        }}
                        onClick={() => handleViewDetails(item.application_id)}
                      >
                        {props.state.language === "ma" ? "വിശദാംശങ്ങൾ കാണിക്കുക" : "View Details"}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {Math.ceil(searchData.length / PageSize) > 1 && (
              <div className="d-flex justify-content-center mt-5">
                <Pagination
                  currentPage={currentPage}
                  totalCount={searchData.length}
                  pageSize={PageSize}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-5 bg-white rounded-4 border border-light">
            <img src="/assets/img/empty-in.svg" alt="Empty" style={{ maxWidth: '120px' }} className="mb-3 opacity-25" />
            <p className="text-muted small">
              {props.state.language === "ma" ? "യാതൊരു രജിസ്ട്രേഷനുകളും കണ്ടുകിട്ടിയില്ല" : "No registered internships found"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
